<template>
  <div class="d-flex justify-center align-center">
    <div
      class="loader"
      :style="
        loader
          ? 'display: block !important; width: 70%;'
          : 'display: none !important;'
      "
    >
      <v-card color="#39424e" max-width="200px" class="pa-4 ma-auto">
        <v-img
          class="mb-4 ma-auto"
          src="../../../assets/logo.svg"
          contain
          max-width="60"
        ></v-img>
        <div style="width: 90%; margin: auto">
          <v-progress-linear indeterminate color="#00c7ba"></v-progress-linear>
        </div>
      </v-card>
    </div>
    <v-card
      :class="loader ? 'main-card-loader ma-2' : 'main-card ma-2'"
      elevation="20"
      min-height="720"
      max-width="1200"
    >
      <Drawer :step="step" :logoParceiro="logoParceiro" />

      <div class="pl-6 d-flex justify-center align-center content">
        <v-window v-model="step" touchless>
          <v-window-item>
            <PessoalInfo @save="save" />
          </v-window-item>

          <v-window-item>
            <v-btn
              style="color: #00c7ba !important"
              class="d-flex align-center mt-4"
              @click="step--"
              elevation="0"
              text
            >
              <v-icon>mdi-arrow-left-circle-outline</v-icon>
              <strong class="ml-2"> Voltar </strong>
            </v-btn>
            <Results
              :key="key"
              :result="model"
              @selectItem="select"
              @stop="stopLoader"
            />
          </v-window-item>

          <v-window-item>
            <v-btn
              style="color: #00c7ba !important"
              class="d-flex align-center mt-4"
              @click="step--"
              elevation="0"
              text
            >
              <v-icon>mdi-arrow-left-circle-outline</v-icon>
              <strong class="ml-2"> Voltar </strong>
            </v-btn>
            <FinalSimulation
              :selectedItem="selectedItem"
              :user="model"
              @confirm="next"
            />
          </v-window-item>

          <v-window-item>
            <v-btn
              class="d-flex align-center mt-4"
              @click="step--"
              elevation="0"
              text
              style="color: #00c7ba !important"
            >
              <v-icon>mdi-arrow-left-circle-outline</v-icon>
              <strong class="ml-2"> Voltar </strong>
            </v-btn>
            <Proposal @confirm="next" />
          </v-window-item>

          <v-window-item>
            <v-btn
              class="d-flex align-center mt-4"
              @click="step--"
              elevation="0"
              text
            >
              <v-icon>mdi-arrow-left-circle-outline</v-icon>
              <strong class="ml-2"> Voltar </strong>
            </v-btn>
            <DPS @confirm="next" />
          </v-window-item>

          <v-window-item>
            <Final :selectedItem="selectedItem" :user="model" />
          </v-window-item>
        </v-window>
      </div>
    </v-card>
  </div>
</template>

<style scoped>
.main-card {
  display: flex;
  border-radius: 25px !important;
  background: #ffffff;
}

.main-card-loader {
  display: flex;
  border-radius: 25px !important;
  filter: blur(15px) !important;
  background: linear-gradient(
    rgba(0, 0, 0, 0.7),
    rgba(0, 0, 0, 0.7)
  ) !important;
}

.content {
  max-width: 70%;
}

.loader {
  position: absolute;
  top: 300px;
  left: 200px;
  z-index: 100;
}

@media (max-width: 960px) {
  .main-card {
    flex-direction: column-reverse;
  }
  .content {
    max-width: unset;
  }
}
</style>

<script>
import Drawer from "./components/drawer.vue";
import PessoalInfo from "./components/pessoalInfo.vue";
import Results from "./components/results.vue";
import FinalSimulation from "./components/finalSimulation.vue";
import Final from "./components/final.vue";
import Proposal from "./components/proposal.vue";
import DPS from "./components/dps.vue";
import ApiService from "../../../services/ApiService";
export default {
  name: "Home",

  data: () => ({
    model: {},
    key: false,
    step: 0,
    selectedItem: null,
    logoParceiro: null,
    apiService: new ApiService(),
    loader: false,
  }),

  components: {
    Drawer,
    PessoalInfo,
    Results,
    FinalSimulation,
    Final,
    DPS,
    Proposal,
  },

  created() {
    this.getLogoParceiroAsync();
    this.$root.$on("stop", () => {
      setTimeout(() => {
        this.loader = false;
      }, 1000);
    });
  },

  methods: {
    save(model) {
      this.model = model;
      this.key = !this.key;
      this.loader = true;
      this.next();
    },

    next() {
      if (this.step < 5) {
        this.step++;
      }
    },

    back() {
      if (this.step > 1) {
        this.step--;
      }
    },

    select(item) {
      this.selectedItem = item;
      this.next();
    },

    stopLoader() {
      this.loader = false;
    },

    async getLogoParceiroAsync() {
      if (this.$route.query.id_parceiro) {
        await this.apiService
          .post("api/logo", { id_parceiro: this.$route.query.id_parceiro })
          .then((response) => {
            this.logoParceiro = response.logo;
          })
          .catch((error) => {});
      } else {
        this.logoParceiro = null;
      }
    },
  },
};
</script>
